"use strict";
exports.__esModule = true;
var rxjs_1 = require("rxjs");
var rxjs_2 = require("rxjs");
var operators_1 = require("rxjs/operators");
// @ts-ignore
var barba = require("@barba/core");
(0, rxjs_2.fromEvent)(window, "DOMContentLoaded", { once: true }).subscribe(function () {
    var $body = window.$("body");
    var $head = window.$("head");
    var TRANSITION_DELAY = 1000;
    var REPLACE_DELAY = 100;
    var timer$ = (0, rxjs_1.timer)(REPLACE_DELAY).pipe((0, operators_1.take)(1));
    // window.twEvents.updateMenuClasses$.subscribe((classes) => {
    //   $body?.$(".MainNavigation")?.setAttribute("class", `MainNavigation ${classes}`);
    // });
    //
    // window.twEvents.updateFooterClasses$.subscribe((classes) => {
    //   $body?.$(".MainFooter")?.setAttribute("class", `MainFooter ${classes}`);
    // });
    //
    // function updateNavigation() {
    //   window.twEvents.updateMenuClasses$.next(
    //     ($body?.$('[data-navigation]') ? $body?.$("[data-navigation]")?.getAttribute("data-navigation") : "") as string
    //   );
    //   window.twEvents.updateFooterClasses$.next(
    //     ($body?.$('[data-footer]') ? `--${$body?.$("[data-footer]")?.getAttribute("data-footer")}` : "") as string
    //   );
    function updateDOM() {
        // updateNavigation();
        var _e = new CustomEvent("dcContentReplaced");
        window.dispatchEvent(_e);
    }
    (0, rxjs_2.fromEvent)($body, "click")
        .pipe((0, operators_1.filter)(function (e) {
        var $link = e.target.closest("a[href]");
        return !!$link && $link.getAttribute("href") === window.location.href;
    }))
        .subscribe(function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
    updateDOM();
    barba.init({
        prefetchIgnore: true,
        prevent: function (el) { return el.href.includes("wp-admin"); },
        transitions: [
            {
                name: "main",
                beforeLeave: function () {
                    $body.$addClass("--fade-out");
                    $body.$removeClass("--fade-in");
                    return new Promise(function (res) { return setTimeout(res, TRANSITION_DELAY); });
                },
                beforeEnter: function () { },
                enter: function () {
                    window.scrollTo(0, 0);
                },
                afterEnter: function (data) {
                    if (data.current.container) {
                        timer$.subscribe(function () {
                            $body.$removeClass("--fade-out");
                            $body.$addClass("--fade-in");
                            updateDOM();
                            window.dataLayer.push({
                                event: "userInfo",
                                contentGroup: document.title || "G5 Web",
                                userid: "",
                                macroArea: "sito"
                            });
                        });
                    }
                }
            },
        ]
    });
});
